import { Link } from "react-router-dom";
import { ArrowRight, FileText } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, Kicker, LineReveal } from "../components/Reveal";
import { PRODUCTS, IMAGES } from "../data/site";

const Products = () => (
    <div data-testid="products-page">
        <PageHero
            kicker="PRODUCT CATALOGUE"
            title="Furnace & Process"
            accent="Heating Systems"
            sub="Electric industrial furnaces, heating systems, control panels and automation — engineered and manufactured to order."
            image={IMAGES.chamber}
            crumb="Products"
        />
        <section className="bg-brand-mist py-20 md:py-24 technical-grid-light">
            <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                    {PRODUCTS.map((p, i) => (
                        <Reveal key={p.slug} delay={Math.min(i * 0.05, 0.4)}>
                            <article className="group flex h-full flex-col bg-white shadow-[0_2px_20px_rgba(15,18,22,0.05)] transition-shadow duration-300 hover:shadow-[0_16px_44px_rgba(15,18,22,0.14)]" data-testid={`product-card-${p.slug}`}>
                                <div className="relative h-56 overflow-hidden">
                                    <img src={p.image} alt={`${p.name} — industrial heating equipment`} loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                                    <span className="absolute left-0 top-0 bg-brand-ink px-3 py-1.5 font-mono text-[10px] tracking-[0.2em] text-brand-ember">{p.tag}</span>
                                </div>
                                <div className="flex flex-1 flex-col p-6">
                                    <h2 className="font-display text-xl font-bold uppercase leading-tight text-brand-charcoal">{p.name}</h2>
                                    <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-500">{p.desc}</p>
                                    <ul className="mt-4 space-y-1.5">
                                        {p.apps.slice(0, 3).map((a) => (
                                            <li key={a} className="flex items-center gap-2 text-xs text-slate-500">
                                                <span className="h-1 w-1 rotate-45 bg-brand-red" /> {a}
                                            </li>
                                        ))}
                                    </ul>
                                    <p className="mt-4 font-mono text-[10px] tracking-[0.14em] text-slate-400 uppercase">Specifications available on request</p>
                                    <div className="mt-5 flex gap-3 border-t border-slate-100 pt-5">
                                        <Link to={`/products/${p.slug}`} data-testid={`product-view-${p.slug}`}
                                            className="flex flex-1 items-center justify-center gap-2 border border-brand-charcoal px-4 py-2.5 font-display text-xs font-bold tracking-[0.12em] text-brand-charcoal transition-colors hover:bg-brand-charcoal hover:text-white">
                                            <FileText size={14} /> VIEW DETAILS
                                        </Link>
                                        <Link to={`/get-a-quote?product=${p.slug}`} data-testid={`product-quote-${p.slug}`}
                                            className="flex flex-1 items-center justify-center gap-2 bg-brand-red px-4 py-2.5 font-display text-xs font-bold tracking-[0.12em] text-white transition-colors hover:bg-brand-charcoal">
                                            REQUEST QUOTE <ArrowRight size={14} />
                                        </Link>
                                    </div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.2}>
                    <div className="mt-16 flex flex-col items-start justify-between gap-6 bg-brand-ink p-8 sm:flex-row sm:items-center md:p-10">
                        <div>
                            <Kicker light>CUSTOM REQUIREMENT?</Kicker>
                            <p className="mt-3 font-display text-2xl font-extrabold uppercase text-white">Every system can be engineered to your process.</p>
                        </div>
                        <Link to="/get-a-quote" data-testid="products-custom-quote"
                            className="group flex shrink-0 items-center gap-3 bg-brand-red px-7 py-4 font-display text-sm font-bold tracking-[0.14em] text-white transition-colors hover:bg-brand-ember">
                            REQUEST A QUOTE <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                        </Link>
                    </div>
                </Reveal>
            </div>
        </section>
    </div>
);

export default Products;
